export const ProceduresPermissions = {
  Update: 'UpdateProcedures',
  CooperativeTraining:
  {
    View: "CooperativeTrianingView",
    ViewAll: "CooperativeTrianingViewAll",
    ViewApproved: "CooperativeTrianingViewApproved",
    Create: "CooperativeTrianingCreate",
    FirstApproval: "CooperativeTrianingFirstApproval",
    SecondApproval: "CooperativeTrianingSecondApproval",
    Delegate: "CooperativeTrianingDelegate",
    FillCertificate: "CooperativeFillCertificate",
    ApproveCertificate: "CooperativeApproveCertificate",
  },
  ExperienceTraining:
  {
    View: 'ExperienceTrianingView',
    Create: 'ExperienceTrianingCreate',
    Approval: 'ExperienceTrianingApproval',
  },
  ExcellenceTraining:
  {
    View: 'ExcellenceTrianingView',
    Create: 'ExcellenceTrianingCreate',
    Approval: 'ExcellenceTrianingApproval',
  },
  TrainingRequest:
  {
    View: "TrianingRequestView",
    Create: "TrianingRequestCreate",
    FirstApproval: "TrianingRequestFirstApproval",
    SecondApproval: "TrianingRequestSecondApproval",
    ThirdApproval: "TrianingRequestThirdApproval",
    ForthApproval: "TrianingRequestForthApproval",
    FifthApproval: "TrianingRequestFifthApproval",
    Delegate: "TrianingRequestDelegate",
    OpinionExpress: "TrianingRequestOpinionExpress",
    ViewApproved: "TrianingRequestViewApproved",
    ViewAll: "TrianingRequestViewAll",
  },
  PractitionersTraining:
  {
    View: "PractitionersTrainingView",
    ViewAll: "PractitionersTrainingViewAll",
    ViewApproved: "PractitionersTrainingViewApproved",
    Create: "PractitionersTrainingCreate",
    FirstApproval: "PractitionersTrainingFirstApproval",
    SecondApproval: "PractitionersTrainingSecondApproval",
  },
  TrainingNeeds:
  {
    View: "TrainingNeedsView",
    ViewAll: "TrainingNeedsViewAll",
    ViewApproved: "PractitionersTrainingViewApproved",
    Create: "TrainingNeedsCreate",
    RegionApproval: "TrainingNeedsRegionApproval",
    DepartmentApproval: "TrainingNeedsDepartmentApproval",
    Delegate: "TrianingNeedsDelegate",
    ChangeRequest: "TrianingNeedsChangeRequest",
    OpinionExpress: "TrianingNeedsOpinionExpress",
  }
};
